import React, { useEffect, useState } from 'react';
import { UserContext } from '../../shared/authentication';
import { Button, DL, DLI, Modal, ContentLink } from '../../shared/components';
import GlobalizedText from '../../shared/globalization';
import { FooterProps } from '../../shared/theme';
import { ajax, getContextPath, win } from '../../shared/utils';
import facebook from './images/facebook.png';
import googlePlus from './images/google-plus.png';
import linkedin from './images/linkedin.png';
import twitter from './images/twitter.png';
import youtube from './images/youtube.png';
import { SubmitYourInquiry } from './submitinquiry';



export function Footer(props: FooterProps) {

    const [version, setVersion] = useState<any>();
    useEffect(() => {
        if (version === undefined) {
            ajax({
                url: '/api/version',
                success: (res) => {
                    setVersion(res);
                },
                error: (error: any) => {
                    setVersion({});
                },
                showMask: false,
            });
        }


    }, [version]);

    if (version === undefined) {
        return <></>
    }



    return <>
        <footer className="foot-container">
            <div className="container">
                <div className="col-wrap row">
                    <div className="foot-col col-1 col-md-6 col-lg-6 hidden-xs hidden-sm">
                        <h2>Sitemap</h2>
                        <ul className="col-box1">
                            <li className="foot-hd">About Us</li>
                            <li><a href="#root">Company</a></li>
                            <li><a href="#root">Newsroom</a></li>
                            <li><a href="#root">Locations</a></li>
                            <li className="foot-hd foot-mt10"><a href="#root">Careers</a></li>
                            <li className="foot-hd">

                            </li>
                        </ul>
                        <ul className="col-box">
                            <li className="foot-hd">Industries</li>
                            <li><a href="#root">Automotive</a></li>
                            <li><a href="#root">Banking & Financial Services</a></li>
                            <li><a href="#root">Energy & Public Sector</a></li>
                            <li><a href="#root">Healthcare Services</a></li>
                            <li><a href="#root">Insurance</a></li>
                            <li><a href="#root">Media & Communications</a></li>
                            <li><a href="#root">Retail & e-Commerce</a></li>
                            <li><a href="#root">Technology</a></li>
                            <li><a href="#root">Travel, Transportation & Tourism</a></li>
                        </ul>
                        <ul className="col-box">
                            <li className="foot-hd">Solutions</li>
                            <li><a href="#root">Customer Lifecycle Management</a></li>
                            <li><a href="#root">Marketing Solutions</a></li>
                            <li><a href="#root">Automation & Process Optimization</a></li>
                            <li><a href="#root">Analytics & Insights</a></li>
                            <li><a href="#root">Consulting</a></li>
                            <li><a href="#root">Finance & Accounting</a></li>
                            <li><a href="#root">IT Services</a></li>
                            <li><a href="#root">Technology Assets</a></li>
                        </ul>
                    </div>
                    <div className="foot-col col-2 col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <h2>Different by Design&trade;</h2>
                        <p>We are a global provider of high value business services. Our focus is on your business imperatives and on improving business outcomes for you. Bringing both strategy and execution, we bring a holistic approach to customer engagement and deploy capabilities and assets to enable improved revenue generation, customer experience and service optimization.</p>
                        <p>We are <em>Different by Design&trade;</em>.</p>
                        <div id="foot-social">
                            <div id="foot-social-wrapper">
                                <div className="foot-social-stack">
                                    <a href="https://www.facebook.com/concentrix.corporation/" rel="noopener noreferrer" target="_blank"><img src={facebook} alt="facebook" /></a>
                                    <a href="https://twitter.com/concentrix" rel="noopener noreferrer" target="_blank"><img src={twitter} alt="twitter" /></a>
                                    <a href="https://plus.google.com/+concentrix" rel="noopener noreferrer" target="_blank"><img src={googlePlus} alt="googlePlus" /></a>
                                    <a href="https://www.linkedin.com/company/concentrix" rel="noopener noreferrer" target="_blank"><img src={linkedin} alt="linkedin" /></a>
                                    <a href="https://www.youtube.com/user/CNXCorporation" rel="noopener noreferrer" target="_blank"><img src={youtube} alt="youtube" /></a>
                                </div>
                                <div className="foot-social-stack">
                                    <img className="foot-img-phone" src={`${getContextPath()}/static/themes/blue/images/phone-icon-1.png`} alt="phone" /><span>+1-800-747-0583</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="foot-copyright">
                    <p>&copy; Copyright Concentrix Insurance Administration Solutions Corporation 2014 All Rights Reserved.<a href="#root" data-toggle="modal" data-target="#version_popup" className="f-version">**</a></p>
                    <a className="f-split" href="#root">Home</a>
                    <a className="f-split" href="https://www.concentrix.com/about-us/company/">About Us</a>
                    <ContentLink typeName="Privacy" displayTxt="Privacy" className="f-split"></ContentLink>
                    <ContentLink typeName="TermsAndCondition" displayTxt="Terms" className="f-split"></ContentLink>
                    <a className="f-split" href="https://www.concentrix.com/about-us/newsroom/">News</a>
                    <a className="f-split" href={`${process.env.PUBLIC_URL}/faq`}>FAQ</a>
                    <UserContext.Consumer>
                        {user => {
                            if (user === null || user.homePageUpdatable === undefined || user.homePageUpdatable === false) {
                                return <></>
                            }
                            if (user.needFirstUpdate || user.needUpdatePwd) {
                                return <a className="f-split" href="#root" id="theme_make_my_workspace" onClick={(e: any) => {
                                    e.preventDefault();
                                }} title="Please update profile first." >Make This My Home Page</a>
                            } else {
                                return <a className="f-split" href="#root" title="Make This My Home Page" onClick={(e: any) => {
                                    ajax({
                                        url: '/api/profile/setDefaultHomepage',
                                        method: 'PUT',
                                        params: {
                                            defaultHomepage: window.location.pathname
                                        }, success: (res: string) => {
                                            props.messageService?.showMessage("success", res);
                                        }
                                    });
                                    e.preventDefault();
                                }} id="theme_make_my_workspace" >Make This My Home Page</a>
                            }
                        }}
                    </UserContext.Consumer>
                    <a id="theme_submit_inquiry_footer" data-toggle="modal" data-target="#theme_inquiry_popup" href="#root">Submit Your Inquiry</a>
                </div>
            </div>
        </footer>
        <SubmitYourInquiry user={props.user}></SubmitYourInquiry>
        <Modal title="common.lbl.portalversion" id="version_popup" footer={() => {
            return <>
                <Button data-dismiss="modal"><GlobalizedText message="common.lbl.close" /></Button></>
        }}>
            <DL>
                <DLI condition={version.productVersion !== undefined} title="common.lbl.productversion" desc={version.productVersion} descId="productVersion"></DLI>
                <DLI condition={version.buildNumber !== undefined} title="common.lbl.buildnumber" desc={version.buildNumber} descId="buildNumber"></DLI>
                <DLI condition={version.buildTime !== undefined} title="common.lbl.buildtime" desc={version.buildTime} descId="buildTimestamp"></DLI>
            </DL>
        </Modal>
    </>
}
